import { Component, EventEmitter, Input, Output, TrackByFunction } from '@angular/core';
import { Context, CrossContextIndicator } from 'libs/context/context.service';

/**
 * Sélecteur de contexte (Sprint 3) — indicateur croisé affiché dans le menu
 * du rôle actif, vers chacun des AUTRES rôles disponibles pour l'identité,
 * avec son nombre de notifications en attente. Purement présentationnel :
 * la logique (quels contextes, quels comptes) vit dans `app.component.ts`,
 * partagée plutôt que dupliquée par menu de rôle.
 */
@Component({
  selector: 'app-cross-context-indicator',
  templateUrl: './cross-context-indicator.component.html',
  styleUrls: ['./cross-context-indicator.component.scss'],
})
export class CrossContextIndicatorComponent {
  @Input() indicators: CrossContextIndicator[] = [];
  @Output() select: EventEmitter<Context> = new EventEmitter();

  /** Compte de notifications rafraîchi en direct : sans trackBy, un re-rendu en cours de clic peut faire tomber le clic sur la mauvaise ligne. */
  trackByContext: TrackByFunction<CrossContextIndicator> = (_, indicator) => indicator.context;
}
